import { createAction, props } from '@ngrx/store';
import { IIncludePaymentRunRequest } from '../models/include-payment-run-request.model';
import { IIncludePaymentRunResponse } from '../models/include-payment-run-response.model';

export const includeInPaymentRun = createAction(
  '[PaymentRun] Include In PaymentRun',
  props<{
    request: IIncludePaymentRunRequest;
  }>()
);

export const includeInPaymentRunSuccess = createAction(
  '[PaymentRun] Include In PaymentRun Success',
  props<{ response: IIncludePaymentRunResponse }>()
);

export const includeInPaymentRunFailure = createAction(
  '[PaymentRun] Include In PaymentRun Failure',
  props<{ error: Error | any }>()
);

export const clearIncludePaymentRunState = createAction(
  '[PaymentRun] Clear Include PaymentRun State'
);